module.exports = __webpack_public_path__ + "img/jiGuang4.386ba1b0.png";